<template>
    <v-autocomplete
        v-model="sale"
        :items="sales"
        :loading="loading"
        :search-input.sync="search"
        hide-no-data
        item-text="title"
        item-value="id"
        label="Vente courante"
        prepend-icon="account_balance"
        single-line
        hide-details
        dense
        return-object />
</template>

<script>
import lodash from 'lodash'

export default {
    name: 'pad-sale-selector',
    data: () => ({
        sales: [],
        loading: false,
        search: ''
    }),
    computed: {
        sale: {
            get() {
                return this.$store.getters['sale/sale']
            },
            set(s) {
                this.$store.commit('sale/setSale', { sale: s })
            }
        }
    },
    watch: {
        search(v) {
            v && this.loadBounce()
        }
    },
    mounted() {
        if (!this.sales.length && this.sale && this.sale.id) {
            this.sales.push({ ...this.sale })
        }
    },
    methods: {
        load() {
            this.loading = true
            this.$api.get(`/sales?q=${this.search || ''}`)
                .then((res) => this.sales = res.data)
                .finally(() => this.loading = false)
        },
        loadBounce: lodash.debounce(function() {
            this.load()
        }, 700)
    }
}
</script>
